import styled from "styled-components";

const SchoolName = styled.h3.attrs({ className: "text-uppercase" })`
  margin-bottom: 2px;
  padding: 0;
`;

export default SchoolName;
